import React from 'react';
import { Text } from '@mantine/core';
import { PRIVACY_POLICY_HREF, TERMS_OF_USE_HREF } from '@/constants';

const ForgotPasswordPolicy: React.FC = () => {
  return (
    <Text mt="lg" size="sm">
      Our{' '}
      <a href={TERMS_OF_USE_HREF} rel="noopener noreferrer" target="_blank">
        Terms of Use
      </a>{' '}
      and{' '}
      <a href={PRIVACY_POLICY_HREF} rel="noopener noreferrer" target="_blank">
        Privacy Policy
      </a>
    </Text>
  );
};

export default ForgotPasswordPolicy;
